/*
 * @flow
 * @author: Chinmaya
 */

export const GOOD_HEALTH = 'GOOD'
export const AVERAGE_HEALTH = 'AVERAGE'
export const POOR_HEALTH = 'POOR'
export const NOT_UPDATED = 'NOT_UPDATED'
